export default __webpack_public_path__ + "static/media/Group 3089.6850e2d9.jpg";